import React from "react";
import UseContext from "hooks/useContext";
import ToolProviderSelect from "pages/missionTemplates/components/ToolProviderSelect";
import { CrossIcon } from "assets/icons";

const TemplateToolList = ({ tools, onProviderChange, onRemove }) => {
    const { language } = UseContext();

    if (!tools?.length) return null;

    const providerSelectLabel = language.getValue(
        "missionTemplate.tools.providerSelectLabel",
        "Fournisseur"
    );
    const removeLabel = language.getValue(
        "missionTemplate.tools.removeLabel",
        "Retirer"
    );

    return (
        <ul className="flex flex-col gap-2">
            {tools.map((tool) => (
                <li
                    key={tool.name}
                    className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-3 bg-white border border-gray-100 rounded-lg"
                >
                    <span className="min-w-0 ft-sm font-medium text-gray-900 break-words">
                        {tool.name}
                    </span>
                    <div className="flex items-center gap-2 ml-auto shrink-0">
                        <ToolProviderSelect
                            value={tool.providedBy}
                            onChange={(providedBy) =>
                                onProviderChange(tool.name, providedBy)
                            }
                            ariaLabel={`${providerSelectLabel} : ${tool.name}`}
                        />
                        <button
                            type="button"
                            onClick={() => onRemove(tool.name)}
                            aria-label={`${removeLabel} ${tool.name}`}
                            className="p-2 rounded-lg hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
                        >
                            <CrossIcon wh={20} color="#111827" />
                        </button>
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default TemplateToolList;
